/**
 * Verifica se a data está no formato `dd/mm/yyyy`.
 *
 * @param data Data a ser testada
 * @returns `true` se a data estiver no formato especificado
 */
export const testarDataBR = (data: string) => {
  const regexDateBR = /^\d{2}\/\d{2}\/\d{4}$/;

  return regexDateBR.test(data);
};

/**
 * Verifica se a data está no formato `yyyy-mm-dd`.
 *
 * @param data Data a ser testada
 * @returns `true` se a data estiver no formato especificado
 */
export const testarDataISO = (data: string) => {
  const regexDateISO = /^\d{4}-\d{2}-\d{2}$/;

  return regexDateISO.test(data);
};

/**
 * Formata uma data no formato Brasileiro (`dd/mm/yyyy`)
 * para o formato ISO (`yyyy-mm-dd`), retornando o próprio parâmetro
 * `dataBr` quando a data fornecida não for um formato válido.
 *
 * @param dataBr Data no formato Brasileiro
 * @returns Data no formato ISO (`yyyy-mm-dd`) ou o
 *   próprio parâmetro `dataBr` quando o formato for inválido
 */
export const formatarDataBRpISO = (dataBr: string) => {
  if (!testarDataBR(dataBr)) {
    return dataBr;
  }

  // Dividir a data no formato dd/mm/yyyy
  const [dia, mes, ano] = dataBr.split('/');

  // Retornar no formato yyyy-mm-dd
  return `${ano}-${mes}-${dia}`;
};

/**
 * Formata uma data no formato ISO (`yyyy-mm-dd`)
 * para o formato Brasileiro (`dd/mm/yyyy`), retornando o próprio parâmetro
 * `dataIso` quando a data fornecida não for um formato válido.
 *
 * @param dataIso Data no formato ISO
 * @returns Data no formato Brasileiro (`dd/mm/yyyy`) ou o
 *   próprio parâmetro `dataIso` quando o formato for inválido
 */
export const formatarDataISOpBR = (dataIso: string) => {
  if (!testarDataISO(dataIso)) {
    return dataIso;
  }

  // Dividir a data no formato dd-mm-yyyy
  const [ano, mes, dia] = dataIso.split('-');

  // Retornar no formato brasileiro dd/mm/yyyy
  return `${dia}/${mes}/${ano}`;
};

/**
 * Formata uma data ISO da seguinte forma:
 * - Se passado como `yyyy-mm-dd` retornará como `dd/mm/yyyy 00:00`;
 * - Se passado como `yyyy-mm-dd HH:MM` retornará como `dd/mm/yyyy HH:MM`;
 * - Se for outro formato retornará o próprio parâmetro `dateTime`.
 *
 * @param dateTime Data e hora ISO a ser formatado
 * @returns Data e hora no formato Brasileiro
 */
export const formatDateTime = (dateTime: string) => {
  const regexDateTimeISO = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(:\d{2})?(\.\d{3})?Z?$/;
  const regexDateISO = /^(\d{4})-(\d{2})-(\d{2})$/;

  if (regexDateISO.test(dateTime)) {
    return dateTime.replace(regexDateISO, '$3/$2/$1 00:00');
  } else if (regexDateTimeISO.test(dateTime)) {
    return dateTime.replace(regexDateTimeISO, '$3/$2/$1 $4:$5');
  } else {
    return dateTime;
  }
};
